import { FormikErrors } from 'formik';
import { ExtendedVoD } from './ExtendedVoD.model';

export const vodVerification = (data: ExtendedVoD) => {
  const errors = {} as FormikErrors<ExtendedVoD>;

  if (!data.name) {
    errors.name = 'Video name is required';
  }

  if (!data.categoryId || data.categoryId === 0) {
    errors.categoryId = 'Sport category is required';
  }

  if (!data.state) {
    errors.state = 'Status is required';
  }

  return errors;
};
